import { create } from "zustand";

const MAX_ENTRIES = 30;

type NavHistoryState = {
  entries: string[];
  push: (path: string) => void;
  removeMatching: (predicate: (path: string) => boolean) => void;
  clear: () => void;
};

export const useNavHistory = create<NavHistoryState>((set) => ({
  entries: [],
  push: (path) =>
    set((state) => {
      const next = [...state.entries, path];
      return { entries: next.slice(-MAX_ENTRIES) };
    }),
  removeMatching: (predicate) =>
    set((state) => ({
      entries: state.entries.filter((path) => !predicate(path)),
    })),
  clear: () => set({ entries: [] }),
}));

export const getPreviousDistinctPath = (
  entries: string[],
  current: string
): string | undefined => {
  for (let i = entries.length - 2; i >= 0; i -= 1) {
    if (entries[i] !== current) return entries[i];
  }
  return undefined;
};
